import Scrollbar from 'smooth-scrollbar';
import { isDesktop } from '../components/exportFunc'
export default ()=>{
    const container = document.querySelector('[circle-container]');
    const halfScreen = window.innerHeight/2;
    let scrollStatus;
    let scrollbar = Scrollbar.get(document.querySelector('.scroll-container'));
    const containerImage = document.querySelector('[centered-image]');

    containerImage&&isDesktop()?imageHandle():false;
    container?circleHandle():false;
    
    function circleHandle(){
        const aside = document.querySelector('.circle');
        const light =  document.querySelector('.wellness-intro__inner');
        const image =container.querySelector('.service-img');
        const top = container.getBoundingClientRect().top;
        const bottom = image.getBoundingClientRect().bottom;
        
        const halfAside = aside.offsetHeight/2;
        const lightBottom = light.getBoundingClientRect().bottom;
        const halfImageHeight = image.offsetHeight /2;
        const innerTextWrapper = aside.querySelector('h2 i');
        const innerText = aside.querySelector('h2 i').innerHTML;
        const changeText = aside.dataset.changeText;
       
        scrollbar.addListener((status) => {
            
            scrollStatus = status.offset.y;
            if ((scrollStatus + halfScreen - halfAside > top) && (bottom - halfImageHeight > scrollStatus + halfScreen + halfAside/2)){
                aside.style.top = scrollStatus + halfScreen - top -  halfAside  + 'px';
            }
            if (scrollStatus + halfScreen - halfAside > lightBottom - halfAside){
                aside.classList.add('light')
                changeText.length>0?innerTextWrapper.innerHTML =  changeText:false;
            } else {
                aside.classList.remove('light');
                changeText.length>0?innerTextWrapper.innerHTML =  innerText:false;
            }
        });
    }

    

    function imageHandle(){
        const image = containerImage.querySelector('.image');
        const top = containerImage.getBoundingClientRect().top;
        const bottom = containerImage.getBoundingClientRect().bottom;
        const halfAside = image.offsetHeight/2;
        scrollbar.addListener((status) => {
            scrollStatus = status.offset.y;
            if ((scrollStatus > top) && (bottom > scrollStatus + halfScreen + halfAside)){
                image.style.top = scrollStatus + halfScreen - top -  halfAside  + 'px';
            }
        });
    }
    
}